import { Config, fetchJSON, Languages, PROVINCE } from '@ratehub/base-ui';
import { getChequingProductShape } from '@ratehub/inv-common';


const API_ENDPOINT = `${Config.CHEQUING_API_URL}/accounts`;

async function fetchProductsForChequing(options) {
    const isSpecificAccountType = options?.accountType && options.accountType !== 'all';

    const params = {
        language: options?.language ?? Languages.ENGLISH,
        province: options?.provinceCode ?? PROVINCE.ONTARIO,

        // for non-specific account types (e.g. 'all'), simply omit accountType
        ...(isSpecificAccountType && { type: options.accountType }),
        ...(options?.provider && { provider: options.provider }),
        ...(!isNaN(options?.monthlyBalance) && {
            balance: Number(options.monthlyBalance),
        }),
        ...(!isNaN(options?.transactions) && {
            transactions: Number(options.transactions),
        }),
        ...(typeof options?.isPrioritizeSponsored === 'boolean' && {
            prioritizeSponsored: options.isPrioritizeSponsored,
        }),
        ...(options.customId && { customId: options.customId }),
    };

    const response = await fetchJSON(
        {
            url: API_ENDPOINT,
            options: {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(params),
            },
        },
        'fetchProductsForChequing',
    );

    // response looks like data: { last_updated: <time string>, products: <array> }
    return {
        lastUpdated: response.data?.lastUpdated,
        products:
            response.data?.products?.map(product =>
                getChequingProductShape(
                    product,
                    isSpecificAccountType,
                ),
            ) || [],
    };
}


export default fetchProductsForChequing;
